
import { createObserver } from '@core/helpers/vue-Intersection-observer'

export default {
  data() {
    return {
      unobserve: null,
      showComponent: false,
      showPlaceholder: true,
    }
  },
  mounted() {
    this.unobserve = createObserver(this.$el, () => {
      this.showPlaceholder = false
      this.showComponent = true
    })
  },
  destroyed() {
    if (this.unobserve) {
      this.unobserve()
    }
  },
}
